import {createContext} from '@lit-labs/context';
import type {DestinationConnection} from '@gl/types/destinations.js';
import type {Nullable} from '@gl/lit/types/general.js';

export type AudienceDestinationContextData = {
  getAll: () => Map<number, DestinationConnection>;
  getById: (id: number) => DestinationConnection | undefined;
  getByTeamId: (id: number) => DestinationConnection | undefined;
  isLoading: () => boolean;
};

// eslint-disable-next-line max-len
export const AudienceDestinationsContext = createContext<
  Nullable<AudienceDestinationContextData>
>('audience-destinations-context');
